import { Component } from '@verndale/core';
import { breakpoints } from '../helpers/variables';

class LogoCarousel extends Component {
  setupDefaults() {
    this.dom = {
      logos: this.el.querySelectorAll('img')
    };
    this.breakpoint = window.matchMedia(`(min-width: ${breakpoints.tablet}px)`);

    this.initSlider();
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this));
    this.breakpoint.addListener(this.restartSlider.bind(this));
  }

  initSlider() {
    if (this.dom.logos && this.dom.logos.length > 1) {
      this.logoWidth = this.dom.logos[0].offsetWidth;
      this.totalWidth = this.logoWidth * this.dom.logos.length;

      if (this.el.offsetWidth > this.totalWidth) return;

      this.el.classList.add('initialized');
      this.animation = window.requestAnimationFrame(
        this.animateLogos.bind(this)
      );
    }
  }

  stopSlider() {
    this.el.classList.remove('initialized');

    this.dom.logos?.forEach(logo => {
      logo.style = null;
      window.cancelAnimationFrame(this.animation);
    });
  }

  restartSlider() {
    this.stopSlider();
    this.initSlider();
  }

  animateLogos() {
    this.dom.logos?.forEach((logo, index) => {
      let newPosition = logo.style.transform
        ? this.getTranslateX(logo)
        : index * this.logoWidth;

      if (newPosition < -this.logoWidth) {
        newPosition = this.totalWidth - this.logoWidth;
      }
      logo.style.transform = `translateX(${newPosition - 0.8}px)`;
    });

    this.animation = window.requestAnimationFrame(this.animateLogos.bind(this));
  }

  getTranslateX(logo) {
    const style = window.getComputedStyle(logo);
    const matrix = new WebKitCSSMatrix(style.transform);
    return matrix.m41;
  }

  handleResize() {
    if (this.dom.logos) {
      const logoWidth = this.dom.logos[0].offsetWidth;
      const totalWidth = logoWidth * this.dom.logos.length;

      if (
        this.el.offsetWidth > totalWidth &&
        this.el.classList.contains('initialized')
      ) {
        this.stopSlider();
      } else if (
        totalWidth > this.el.offsetWidth &&
        !this.el.classList.contains('initialized')
      ) {
        this.initSlider();
      }
    }
  }
}

export default LogoCarousel;
